import { useEffect } from "react";
import getWindow from "../utils/window";

export default function useEventListener(
  eventName,
  callback,
  dependencies,
  target,
  options,
) {
  useEffect(() => {
    const eventTarget = target ?? getWindow();
    if (!eventTarget) return;

    eventTarget.addEventListener(eventName, callback, options);

    return () => eventTarget?.removeEventListener(eventName, callback, options);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
}
